import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { ADMIN_NOTIFICATION_FEED_QUERY_KEY } from './useGetAdminNotifications';
import { ADMIN_NOTIFICATION_UNREAD_COUNT_QUERY_KEY } from './useGetUnreadCount';

export const useMarkAsRead = (organizationId?: string) => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (notificationId: string) => {
      await client.fetchApi({
        endpoint: `notifications/admin/${notificationId}/read?organizationId=${organizationId}`,
        method: 'PATCH',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([ADMIN_NOTIFICATION_FEED_QUERY_KEY]);
      queryClient.invalidateQueries([ADMIN_NOTIFICATION_UNREAD_COUNT_QUERY_KEY]);
    },
  });
};
